/**
 * x_tarificador-cart-rates-sync.js
 * Sincronización bidireccional entre popup y carrito
 */
(function() {
  'use strict';
  
  window.HACIENDOLA = window.HACIENDOLA || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR || {};
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS || {};
  
  /**
   * Sincroniza selectores entre popup y carrito
   * @param {string} sourceType - 'popup' o 'cart'
   * @param {string} provinceCode - Código de la provincia
   * @param {string} cityName - Nombre de la ciudad
   */
  window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.FUNCTIONS.syncSelectors = (sourceType, provinceCode, cityName) => {
    console.log('🔄 Sincronizando desde:', sourceType, { provinceCode, cityName });
    
    // Prevenir loops infinitos
    if (window.HACIENDOLA._syncing) {
      console.log('⏭️ Ya sincronizando, saltando...');
      return;
    }
    window.HACIENDOLA._syncing = true;
    
    // Determinar selectores origen y destino
    let targetProvinceSelect, targetCitySelect;
    
    if (sourceType === 'popup') {
      targetProvinceSelect = document.getElementById('pscCartDropdownProvinceSelect');
      targetCitySelect = document.getElementById('pscCartDropdownCitySelect');
    } else {
      targetProvinceSelect = document.getElementById('popupProvinceSelect');
      targetCitySelect = document.getElementById('popupCitySelect');
    }
    
    if (!targetProvinceSelect || !targetCitySelect) {
      console.log('⚠️ Selectores destino no encontrados');
      window.HACIENDOLA._syncing = false;
      return;
    }
    
    // Sincronizar provincia
    if (provinceCode && provinceCode !== '0') {
      targetProvinceSelect.value = provinceCode;
      
      const provinces = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.provincesWithCities || [];
      const selectedProvince = provinces.find(x => x.provinceCode == provinceCode);
      
      if (selectedProvince) {
        const textValues = window.HACIENDOLA.PERSONALIZED_SHIPPING_CALCULATOR.textValues || {};
        let htmlCities = '<option value="0">' + (textValues['CHOOSE_CITY_TEXT'] || '') + '</option>';
        
        selectedProvince.provinceCities.forEach(
          x => (htmlCities += '<option value="' + x.cityName + '">' + x.cityName + '</option>')
        );
        
        targetCitySelect.innerHTML = htmlCities;
        targetCitySelect.disabled = false;
        targetCitySelect.classList.remove('hidden');
        
        console.log('✅ Provincia sincronizada, ciudades cargadas:', selectedProvince.provinceCities.length);
      }
    }
    
    // Sincronizar ciudad con delay
    setTimeout(() => {
      if (cityName && targetCitySelect.options.length > 1) {
        let cityFound = false;
        
        for (let i = 0; i < targetCitySelect.options.length; i++) {
          if (targetCitySelect.options[i].text === cityName) {
            targetCitySelect.selectedIndex = i;
            targetCitySelect.value = targetCitySelect.options[i].value;
            cityFound = true;
            console.log('✅ Ciudad sincronizada:', cityName);
            break;
          }
        }
        
        if (!cityFound) {
          console.warn('⚠️ Ciudad no encontrada:', cityName);
        }
      }
      
      window.HACIENDOLA._syncing = false;
    }, 100);
  };
})();